var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"loading",class:[{ slim: _vm.slim }, _vm.site]},[_c('div',{staticClass:"loader"}),_c('div',{staticClass:"loading-message"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }